import Vue from "vue";
export default {
    namespaced: true,
    state: {
        booking_status: []
    },
    mutations: {
        setBookingStatusMutation(state, payload) {
            state.booking_status = [...payload]
        }
    },
    getters: {
        getBookingStatusGetters: state => state.booking_status
    },
    actions: {
        send_request( context, payload){           
            Vue.axios.post('api/itinerary/booking/send_booking_request', payload)
                .then(() => {
            })
            context.dispatch('api/itinerary/update_booking_status_action', payload.data[0], {root: true}) 
        },
        setBookingStatusAction({commit}, payload) {
            commit('setBookingStatusMutation', payload)
        }
    }
}
